/*
  Franchise (round 38): what moves on sections/vr-franchise.liquid (the opening's curtain and crackers are
  assets/vr-franchise-opening.js, round 52; the ribbon and the opening lights are CSS).
  - opening day: as the chapter is read, its moments follow one another, the photograph and the words changing
    together and a row of small diamonds marking the hour;
  - the rooms and the pillars rise into place as they come into view, a little one after another.
*/
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function day(root) {
    var sec = root.querySelector('[data-vrfr-day]');
    if (!sec) return;
    var moments = Array.prototype.slice.call(sec.querySelectorAll('[data-vrfr-moment]'));
    var photos = Array.prototype.slice.call(sec.querySelectorAll('[data-vrfr-photo]'));
    var hours = Array.prototype.slice.call(sec.querySelectorAll('.vrfr-day__hour'));
    var n = moments.length, current = 0, ticking = false;
    if (!n) return;
    var show = function (i) {
      if (i === current) return;
      current = i;
      moments.forEach(function (m, k) { m.classList.toggle('is-active', k === i); });
      photos.forEach(function (p) { p.classList.toggle('is-active', +p.getAttribute('data-vrfr-photo') === i); });
      hours.forEach(function (h, k) { h.classList.toggle('is-active', k <= i); });
    };
    var read = function () {
      ticking = false;
      var r = sec.getBoundingClientRect();
      var run = r.height - window.innerHeight;
      if (run <= 0) return;
      var p = Math.max(0, Math.min(0.9999, -r.top / run));
      show(Math.floor(p * n));
    };
    var onScroll = function () { if (!ticking) { ticking = true; window.requestAnimationFrame(read); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    read();
    /* round 50: an upright photograph is shown whole on a computer (the frame is wide), over a blurred copy of itself */
    photos.forEach(function (p) {
      var im = p.querySelector('img');
      if (!im) return;
      var mark = function () { if (im.naturalHeight > im.naturalWidth * 1.05) p.classList.add('is-upright'); };
      if (im.complete && im.naturalWidth) mark(); else im.addEventListener('load', mark, { once: true });
    });
    /* the next photographs are fetched before they are needed */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { photos.forEach(function (p) { var im = p.querySelector('img') || p; im.loading = 'eager'; }); io.disconnect(); } });
      }, { rootMargin: '600px 0px' });
      io.observe(sec);
    }
  }

  function reveal(root) {
    if (reduce || !('IntersectionObserver' in window)) return;
    var els = Array.prototype.slice.call(root.querySelectorAll('[data-vrfr-reveal]'));
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        e.target.classList.add('is-in');
      });
    }, { threshold: 0.18 });
    var row = -1, top = null;
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) return;
      if (top === null || Math.abs(r.top - top) > 40) { top = r.top; row = 0; } else row++;
      el.style.setProperty('--d', row);
      el.classList.add('is-armed');
      io.observe(el);
    });
  }

  function init(root) {
    var vrfr = root.matches && root.matches('[data-vrfr]') ? root : root.querySelector('[data-vrfr]');
    if (!vrfr || vrfr.dataset.vrfrReady) return;
    vrfr.dataset.vrfrReady = '1';
    day(vrfr);
    reveal(vrfr);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
